/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Component,
  Input,
  OnChanges,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import {
  ReportBoxVm,
  ReportContext,
  ReportEntryId,
  ReportStateService,
} from 'src/app/shared/services/report-state.service';

@Component({
  selector: 'app-report-box',
  templateUrl: './report-box.component.html',
  styleUrls: ['./report-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportBoxComponent implements OnChanges {
  @Input() entity: any;
  @Input() folio: any;
  @Input() customScore: string;
  @Input() mode: 'entity' | 'query' = 'entity';
  @Input() buttonLabel = 'Report';
  @Input() cardClass = '';

  private readonly ctxSubject = new ReplaySubject<ReportContext>(1);
  readonly vm$: Observable<ReportBoxVm> = this.reportStateService.getViewModel$(
    this.ctxSubject.asObservable(),
  );

  constructor(public reportStateService: ReportStateService) {}

  ngOnChanges(): void {
    this.ctxSubject.next(this.buildContext());
  }

  onClick(id: ReportEntryId): void {
    this.reportStateService.dispatchReport(id, this.buildContext());
  }

  trackById = (_: number, entry: { id: ReportEntryId }) => entry.id;

  private buildContext(): ReportContext {
    if (this.mode === 'query') {
      return { mode: 'query' };
    }
    return {
      mode: 'entity',
      entity: this.entity,
      folio: this.folio,
      customScore: this.customScore,
    };
  }
}
